import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-img-icone',
  templateUrl: './img-icone.component.html',
  styleUrls: ['./img-icone.component.scss']
})
export class ImgIconeComponent implements OnInit {

  @Input() set src(value: string) {

    this.srcCopy = value;
    this.convertImgToFront(this.srcCopy);
  }

  srcCopy: string;

  url: SafeResourceUrl;

  constructor(
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
  }

  convertImgToFront(src) {
    const objectURL = 'data:image/svg+xml;base64,' + src;
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(objectURL);
  }

}
